export default function() {
    const form = document.getElementById('careers-form');
    if (!form) {
        return;
    }

    const validator = new ContactFormValidator({
        element: form
    });

    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        if (!await validator.isValid()) {
            return false;
        }

        const formData = new FormData(form);
        validator.preventInput();

        $.ajax({
            type: "POST",
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            url: form.getAttribute('action'),
            data: formData,
            success: function(response) {
                validator.allowInput();

                var div = $('<div class="careers-thankyou"></div>');

                div.append('<h1>Thank you for your application</h1>');
                div.append('<p>We have received your application and a member of our team will be in touch shortly with the next steps.</p><img height=1 width=1 border=0 src="//conv.indeed.com/pagead/conv/3986726972655674/?script=0">');

                $('html, body').animate({
                    scrollTop: $('.careers-form').offset().top - 80
                }, 'slow');

                $('#careers-form').html(div);
                $('.careers-modal')[0].scrollIntoView();

                dataLayer.push({
                    'event' : 'trackEvent',
                    'eventCategory' : 'Careers - Apply For This Job',
                    'eventAction' : 'Form Complete',
                    'eventLabel' : 'Complete',
                    'eventValue' : 0,
                });
            },
            error: function(response) {
                // $('.please-wait').hide();

                // $('html, body').animate({
                //     scrollTop: $('.careers-form').offset().top - 80
                // }, 'slow');
                validator.errorResponse(response);
                // outputErrorToForm('careers-form', parseErrorResponse(response));
            }
        });
    });
}